import { Table, Button, Row, Col, Form, Pagination } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Message from './../components/Message';
import Loader from './../components/Loader';
import { useGetSalesQuery, useDeleteSaleMutation } from './../slices/salesApiSlice';
import { toast } from 'react-toastify';
import { useState } from 'react';


const StaffSale = () => {
  // State for filtering, pagination, and date range
  const [filter, setFilter] = useState('');
  const [pageNumber, setPageNumber] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  // Fetch paginated sales data
  const { data, isLoading, error, refetch } = useGetSalesQuery(pageNumber);

  // Mutation for deleting sales
  const [deleteSale, { isLoading: loadingDelete }] = useDeleteSaleMutation();

  // Handle sale deletion
  
  const deleteHandler = async (id) => {
    if (window.confirm('Are you sure you want to delete this sale?')) {
      try {
        await deleteSale(id).unwrap();
        toast.success('Sale deleted successfully!');
        refetch(); // Refetch sales after successful deletion
      } catch (err) {
        toast.error(err?.data?.message || 'Failed to delete sale.');
      }
    }
  };

  // Filter sales data based on product name, note, and date range
  const filterSales = () => {
    if (!data?.sales) return [];
    return data.sales.filter((sale) => {
      const saleDate = new Date(sale.date);
      const isWithinDateRange =
        (!startDate || saleDate >= new Date(startDate)) &&
        (!endDate || saleDate <= new Date(endDate));
      return (
        isWithinDateRange &&
        (sale.note?.toLowerCase().includes(filter.toLowerCase()) || // Check note
          sale.customerDetails?.name?.toLowerCase().includes(filter.toLowerCase()) || // Check customer name  
          sale.saleItems.some((item) =>
            item.name.toLowerCase().includes(filter.toLowerCase()) // Check product name
          ))
      );
    });
  };

  // Calculate total sales
  const calculateTotalSales = () => {
    return filterSales().reduce((total, sale) => {
      const saleTotal = sale.saleItems.reduce(
        (subTotal, item) => subTotal + item.qty * item.price,
        0
      );
      return total + saleTotal;
    }, 0);
  };

  // Handle pagination changes
  const paginationHandler = (page) => {
    setPageNumber(page);
  };

  return (
    <>
      <Row className="align-items-center mb-3">
        <Col>
          <h1>Sales</h1>
        </Col>
        <Col md={4}>
          <Form.Control
            type="text"
            placeholder="Filter by product name or note"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={3}>
          <Form.Control
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            placeholder="Start Date"
          />
        </Col>
        <Col md={3}>
          <Form.Control
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            placeholder="End Date"
          />
        </Col>
        <Col md={6} className="text-end">
          <h4>Total Sales: ${calculateTotalSales().toFixed(2)}</h4>
        </Col>
      </Row>

      {loadingDelete && <Loader />}
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || 'An error occurred'}
        </Message>
      ) : (
        <>
          <Table striped bordered hover responsive className="table-sm">
            <thead>
              <tr>
                <th>DATE</th>
                <th>PRODUCT NAME</th>
                <th>QTY</th>
                <th>TOTAL</th>
                <th>NOTE</th>
                <th>CUSTOMER</th>
                <th>IMAGE</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {filterSales().map((sale) =>
                sale.saleItems.map((item) => (
                  <tr key={`${sale._id}-${item.product}`}>
                    <td>{new Date(sale.date).toLocaleDateString()}</td>
                    <td>{item.name}</td>
                    <td>{item.qty}</td>
                    <td>${(item.qty * item.price).toFixed(2)}</td>
                    <td>{sale.note || 'N/A'}</td>
                    <td>{sale.customerDetails.name || 'N/A'}</td>
                    <td>
                      {item.images && (
                        <img
                          src={item.images[0]}
                          alt="Thumbnail"
                          className="thumbnail-img me-2"
                          style={{
                            width: '40px',
                            height: '40px',
                            objectFit: 'cover',
                            borderRadius: '5px',
                          }}
                        />
                      )}
                    </td>
                    <td>
                      <Button

                        as={Link}
                        to={`/sale/${sale._id}`}
                        variant="light"
                        className="btn-sm"
                      >
                        Details
                      </Button>
                      <Button
                        style={{ display: 'none' }}
                        as={Link}
                        to={`/admin/sale/${sale._id}/edit`}
                        variant="light"
                        className="btn-sm mx-2"
                      > 
                      Edit
                      </Button>      
                      <Button
                        style={{ display: 'none' }}
                        variant="danger"
                        className="btn-sm mx-2"
                        onClick={() => deleteHandler(sale._id)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>

          {/* Pagination */}
          <Pagination>
            {[...Array(data.pages).keys()].map((x) => (
              <Pagination.Item
                key={x + 1}
                active={x + 1 === pageNumber}
                onClick={() => paginationHandler(x + 1)}
              >
                {x + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </>
      )}
    </>
  );
};

export default StaffSale;